<template>
    <rkm-area title="Observações">
        <Form
            :data="data"
            :readonly="readonly"
        />
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
}
</script>